import { useState, useEffect } from 'react';
import { FaBars, FaSearch } from "react-icons/fa";
import { CCol, CRow, CHeaderNav, CNavItem, CNavLink } from '@coreui/react';
import '../../assets/css/mainstyle.css';
import '../../assets/css/responsive.css';
import Adminprofil from '../../assets/images/adminprofil.png'
import api from '../../service/caller';
import { ToastContainer, toast } from 'react-toastify';
import DoctorDashboard from '../Doctorinterface/dashboard';
import '../Rapport/repport.css';
import { BarChart } from '@mui/x-charts/BarChart';
import { LineChart } from '@mui/x-charts/LineChart';
import Stack from '@mui/material/Stack';
import { Typography, Button } from '@mui/material';
import { Gauge } from '@mui/x-charts/Gauge';
import { PieChart } from '@mui/x-charts/PieChart';
import Box from '@mui/material/Box';
import { getUserIdFromToken } from '../../utils/authUtils';
import NurseDashboard from './DashboardNurse';
import CasierDashboard from './DashboardCasier';

const DashboardPage = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [userData, setUserData] = useState([]);
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);
  const [selectedTrend, setSelectedTrend] = useState('Consultation');
  const [hospitals, setHospitals] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [message, setMessage] = useState('');
  const [selectedPeriod, setSelectedPeriod] = useState('year');
  const [trendsData, setTrendsData] = useState({});
  const [loading, setLoading] = useState(false);
  const [weeklyGrowth, setWeeklyGrowth] = useState(0);
  const userId = getUserIdFromToken();
  const [showComparison, setShowComparison] = useState(false);
  const [otpStage, setOtpStage] = useState(false);


  // Added for chart toggle functionality
  const [chartType, setChartType] = useState('bar'); // 'bar' or 'pie'

  // Added for comparison feature
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [selectedYear1, setSelectedYear1] = useState(new Date().getFullYear());
  const [selectedYear2, setSelectedYear2] = useState(new Date().getFullYear());
  const [comparisonYear, setComparisonYear] = useState(new Date().getFullYear() - 1);
  const [comparisonData, setComparisonData] = useState([]);

  // Fonction pour basculer l'affichage
  const toggleComparison = () => {
    setShowComparison((prev) => !prev);
    if (!showComparison) {
      fetchComparisonData();
    }
  };

  // State for API data
  const [appointmentStats, setAppointmentStats] = useState([]);
  const [patientTrends, setPatientTrends] = useState([]);
  const [heatmapData, setHeatmapData] = useState({
    data: Array(7).fill().map(() => Array(10).fill(0)),
    days: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
    hours: ['8:00', '9:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00']
  });
  const [insights, setInsights] = useState({
    totalPatients: 0,
    hospitalizations: 0,
    surgeries: 0,
    accouchements: 0,
    totalDoctors: 0,
    successRate: 0,
    totalAppointments: 0,
    criticalRate: 0
  });
  const [appointmentDistribution, setAppointmentDistribution] = useState([]);

  // Filter states
  const [selectedHospital, setSelectedHospital] = useState('');
  const [selectedMonth, setSelectedMonth] = useState('');
  const [selectedDepartment, setSelectedDepartment] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchLoggedUserData = async () => {
      try {
        const response = await api.get('api/usersprofile');
        setUserData(response.data);
      } catch (error) {
        toast.error("Failed to fetch user profile data");
      }
    };
    fetchLoggedUserData();
  }, []);

  useEffect(() => {
    if (userData?.firstlogin) {
      toast.warn("Veuillez changer votre mot de passe pour sécuriser votre compte.");
      setOtpStage(true);
    }
  }, []);

  // Fetch appointment statistics
  useEffect(() => {
    const fetchAppointmentStats = async () => {
      try {
        setIsLoading(true);
        const params = new URLSearchParams();
        params.append('year', selectedYear);
        if (selectedHospital) params.append('hospitalId', selectedHospital);
        if (selectedDepartment) params.append('departmentId', selectedDepartment);

        const response = await api.get(`api/appointment-stats?${params.toString()}`);
        setAppointmentStats(response.data);
      } catch (error) {
        toast.error("Failed to fetch appointment statistics");
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchAppointmentStats();
  }, [selectedHospital, selectedYear, selectedDepartment]);

  // Fetch patient trends
  useEffect(() => {
    const fetchPatientTrends = async () => {
      try {
        setIsLoading(true);
        const params = new URLSearchParams();
        params.append('year', selectedYear1);
        if (selectedHospital) params.append('hospitalId', selectedHospital);
        if (selectedDepartment) params.append('departmentId', selectedDepartment);

        const response = await api.get(`api/patient-trends?${params.toString()}`);
        // Add year indicator to each data point
        const dataWithYear = response.data.map(item => ({
          ...item,
          year: selectedYear1,
          label: `${item.month} ${selectedYear1}`
        }));
        setPatientTrends(dataWithYear);
      } catch (error) {
        toast.error("Failed to fetch patient trends");
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchPatientTrends();
  }, [selectedHospital, selectedYear1, comparisonYear, selectedDepartment]);

  // New function to fetch comparison data
  const fetchComparisonData = async () => {
    try {
      setIsLoading(true);
      const params = new URLSearchParams();
      params.append('year', comparisonYear);
      if (selectedHospital) params.append('hospitalId', selectedHospital);
      if (selectedDepartment) params.append('departmentId', selectedDepartment);

      const response = await api.get(`api/patient-trends?${params.toString()}`);
      // Add year indicator to each data point
      const dataWithYear = response.data.map(item => ({
        ...item,
        year: comparisonYear,
        label: `${item.month} ${comparisonYear}`
      }));
      setComparisonData(dataWithYear);
    } catch (error) {
      toast.error("Failed to fetch comparison data");
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  // Call comparison data fetch when comparison year changes
  useEffect(() => {
    if (showComparison) {
      fetchComparisonData();
    }
  }, [comparisonYear, selectedHospital, selectedYear1, selectedDepartment]);

  // Fetch heatmap data
  useEffect(() => {
    const fetchHeatmapData = async () => {
      try {
        setIsLoading(true);
        const params = new URLSearchParams();
        if (selectedHospital) params.append('hospitalId', selectedHospital);

        const response = await api.get(`api/appointment-heatmap?${params.toString()}`);
        setHeatmapData(response.data);
      } catch (error) {
        toast.error("Failed to fetch appointment heatmap data");
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchHeatmapData();
  }, [selectedHospital]);

  // Fetch insights data
  useEffect(() => {
    const fetchInsights = async () => {
      try {
        setIsLoading(true);
        const params = new URLSearchParams();
        params.append('year', selectedYear2);
        // if (selectedHospital) params.append('hospitalId', selectedHospital);
        // if (selectedMonth) params.append('month', selectedMonth);

        const response = await api.get(`api/insights?${params.toString()}`);
        setInsights(response.data);
      } catch (error) {
        toast.error("Failed to fetch insights data");
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchInsights();
  }, [selectedYear2]);

  useEffect(() => {
    const fetchHospitals = async () => {
      if (!userId) {
        setMessage('Utilisateur non authentifié.');
        return;
      }
      try {
        setLoading(true);
        const token = localStorage.getItem('access_token');
        const response = await api.get(`/api/hospitals/admin/` + token, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('access_token')}`
          }
        });
        setHospitals(response.data);
        setLoading(false);
      } catch (error) {
        console.error('Erreur lors de la récupération des hôpitaux:', error);
        setMessage('Erreur lors de la récupération des hôpitaux.');
        setLoading(false);
      }
    };
    if (userId) {
      fetchHospitals();
    }
  }, [userId]);

  // Charger les départements lorsqu'un hôpital est sélectionné
  useEffect(() => {
    const fetchDepartments = async () => {
      if (!selectedHospital) return;
      try {
        setLoading(true);
        const hospitalId = selectedHospital;
        const response = await api.get(`/api/departments/hospital/${hospitalId}`, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
          }
        });
        setDepartments(response.data.data);
        setLoading(false);
      } catch (error) {
        console.error('Erreur lors de la récupération des départements:', error);
        setMessage('Erreur lors de la récupération des départements.');
        setLoading(false);
      }
    };
    fetchDepartments();
  }, [selectedHospital]);

  // Fetch appointment distribution for pie chart
  useEffect(() => {
    const fetchAppointmentDistribution = async () => {
      try {
        setIsLoading(true);
        const params = new URLSearchParams();
        params.append('year', selectedYear);
        if (selectedHospital) params.append('hospitalId', selectedHospital);

        const response = await api.get(`api/appointment-distribution?${params.toString()}`);
        setAppointmentDistribution(response.data);
      } catch (error) {
        toast.error("Failed to fetch appointment distribution");
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchAppointmentDistribution();
  }, [selectedHospital, selectedYear]);

  let dateActuelle = new Date();
  let jour = dateActuelle.getDate();
  let mois = dateActuelle.getMonth();
  let moisNoms = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  let dateFormatee = `${jour} / ${mois + 1} / ${moisNoms[mois]}`;

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);
  const isDoctor = userData.role?.name;

  // Helper function to get cell class based on value
  const getCellClass = (value) => {
    if (value >= 16) return 'heatmap-cell-highest';
    if (value >= 10) return 'heatmap-cell-high';
    if (value >= 6) return 'heatmap-cell-medium';
    if (value >= 4) return 'heatmap-cell-low';
    return 'heatmap-cell-lowest';
  };


  const currentYearData = showComparison ?
    patientTrends.filter(item => item?.year == selectedYear1) :
    patientTrends;

  const comparisonYearData = showComparison ?
    comparisonData.filter(item => item?.year == comparisonYear) :
    [];

  // Function to render the appropriate chart based on chartType
  const renderAppointmentChart = () => {


    if (chartType === 'bar') {
      return (
        <BarChart
          className='barch'
          xAxis={[{ scaleType: "band", data: appointmentStats.map((item) => String(item.month)) }]}
          series={[{ data: appointmentStats.map((item) => item.value) }]}
        // borderRadius={50}
        />
      );
    } else {
      // Prepare data for pie chart
      return (
        <PieChart
          className='piechart'
          series={[
            {
              data: appointmentStats.map((item, index) => ({
                id: index,
                value: item.value,
                label: item.category || item.month
              })),
              innerRadius: 30,
              outerRadius: 100,
              paddingAngle: 2,
              cornerRadius: 5,
              startAngle: -90,
              endAngle: 270,
            }
          ]}
          height={300}
          margin={{ top: 10, bottom: 80, left: 10, right: 10 }}
          slotProps={{
            legend: {
              direction: 'row',
              position: { vertical: 'bottom', horizontal: 'middle' },
              padding: 20,
            },
          }}
        />
      );
    }
  };

  return (
    <CRow>
      <CCol xs={12}>
        <ToastContainer />
        <div className="dashboard-header">
          {/* En-tête de profil utilisateur amélioré */}
          <div className="hosp-profile-header" style={{ backgroundColor: 'var(--hosp-background-color)', border: "none" }}>
            <div className="hosp-header__content">
              {/* Titre à gauche */}
              <div className="hosp-header__title">
                <h4 className="hosp-page__title"><b>Dashboard</b></h4>
              </div>

              {/* Profil utilisateur à droite */}
              <div className="hosp-user__profile">
                {/* Indicateur de statut en ligne (optionnel) */}
                <div className="hosp-status__indicator"></div>

                <img
                  src={userData?.picture || Adminprofil}
                  className='hosp-profile__image'
                  alt="Profile Icon"
                />

                <div className="hosp-user__details">
                  <span className="hosp-user__name">{userData.firstname} {userData.lastname}</span>
                  <p className="hosp-user__role">
                    {userData.role?.name?.replace(/^medtinz_client_/, '').replace(/_/g, ' ')}
                  </p>
                </div>
              </div>
            </div>
          </div>
          {isDoctor === "medtinz_client_doctor" ? (
            <DoctorDashboard />
          ) : isDoctor === "medtinz_client_nurses" ? (
            <NurseDashboard />
          ) : isDoctor === "medtinz_client_cashier" ? (
            <CasierDashboard />
          ) : (
            <div>
              <div className="header-background mt-4">
                <div className="header-text px-5">
                  <div className="header-date">{dateFormatee}</div>
                  <h2>Good morning, {userData?.role?.name?.replace(/^medtinz_client_/, '').replace(/_/g, ' ')} {userData.firstname}</h2>
                  <p>Have a nice day at work, it seems that you are <br /> returning to Daniel Bruh</p>
                </div>
              </div>

              <div className='fist-container'>
                <div className='bar-cont'>
                  <div className='cont-header'>
                    <span>Appointments</span>
                    {/* Add chart type toggle button */}
                    <div className="chart-toggle">
                      <Button
                        variant={chartType === 'bar' ? "contained" : "outlined"}
                        onClick={() => setChartType('bar')}
                        sx={{ mr: 1 }}
                      >
                        Bar Chart
                      </Button>
                      <Button
                        variant={chartType === 'pie' ? "contained" : "outlined"}
                        onClick={() => setChartType('pie')}
                      >
                        Pie Chart
                      </Button>
                    </div>
                  </div>

                  <div className='les-filtres'>
                    <select
                      className="stat-select"
                      value={selectedHospital}
                      onChange={(e) => setSelectedHospital(e.target.value)}
                    >
                      <option value="">All Hospitals</option>
                      {hospitals.map((hospital, index) => (
                        <option key={index} value={hospital._id}>
                          {hospital.hospital_name}
                        </option>
                      ))}
                    </select>

                    <div className='filtres2'>
                      <select
                        className="stat-select"
                        value={selectedYear}
                        onChange={(e) => setSelectedYear(e.target.value)}
                      >
                        {Array.from({ length: 10 }, (_, i) => {
                          const year = new Date().getFullYear() - i;
                          return <option key={year} value={year}>{year}</option>;
                        })}
                      </select>

                      <select
                        className="stat-select"
                        value={selectedDepartment}
                        onChange={(e) => setSelectedDepartment(e.target.value)}
                      >
                        <option value="">All Departments</option>
                        {departments.map((dept, index) => (
                          <option key={index} value={dept._id}>
                            {dept.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  {/* Call the rendering function here */}
                  {renderAppointmentChart()}
                </div>

                <div className='insights-container'>
                  <div className='insights'>
                    <div className="insights-header">
                      <h2>Insights</h2>
                      <select
                        className="stat-select"
                        style={{ padding: "8px 50px", backgroundColor: "white" }}
                        value={selectedYear2}
                        onChange={(e) => setSelectedYear2(e.target.value)}
                      >
                        {Array.from({ length: 10 }, (_, i) => {
                          const year = new Date().getFullYear() - i;
                          return <option key={year} value={year}>{year}</option>;
                        })}
                      </select>
                    </div>

                    <div className="insights-content">
                      {/* Cards de statistiques */}
                      <div className="stats-row">
                        <div className="stat-card">
                          <div className="stat-label">Total Patients</div>
                          <div className="stat-value">{insights.totalPatients}</div>
                        </div>

                        <div className="stat-card">
                          <div className="stat-label">Total appointments</div>
                          <div className="stat-value">{insights.totalAppointments}</div>
                        </div>

                        <div className="stat-card">
                          <div className="stat-label">Total number of Doctors</div>
                          <div className="stat-value">{insights.totalDoctors}</div>
                        </div>
                      </div>

                      {/* Jauges */}
                      <div className="gauges-row">
                        <div className="gauge-item">
                          <Gauge className='sucess-gauge' width={100} height={100} value={insights.successRate} />
                          <span>Success cases</span>
                        </div>

                        <div className="gauge-item">
                          <Gauge className='low-gauge' width={100} height={100} value={insights.criticalRate} />
                          <span>Critical case</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </CCol>
    </CRow>
  );
}

export default DashboardPage;